export const CURRENCY_USDT = "USDT"

export const CURRENCY_USDT_TRC20 = "USDT (TRC20)"